import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
import Vuei18n from "vue-i18n";
import md5 from 'js-md5';
import axios from 'axios'
// 前端异常情况捕获
Vue.prototype.$md5 = md5;
Vue.use(Vuei18n);
Vue.use(Lazyload);
Vue.use(Vant);
// const i18n = new Vuei18n({
//     locale: window.location.search.substr(1).split('=')[1] || window.localStorage.getItem('language') || 'en-US',
//     messages: {
//         'zh-CN': require('@/assets/lang/zh_CN.json'),
//         'en-US': require('@/assets/lang/en_US.json'),
//         'zh-TW': require('@/assets/lang/zh_HK.json'),
//         'zh-HK': require('@/assets/lang/zh_HK.json'),
//         'ko-KR': require('@/assets/lang/ko_KR.json'),
//         'id-ID': require('@/assets/lang/id_ID.json'),
//         'ja-JP': require('@/assets/lang/ja_JP.json'),
//         'th-TH': require('@/assets/lang/th_TH.json'),
//     }
// });
// window.i18n = i18n

const i18n = new Vuei18n({
    locale: 'en-US',
});
window.i18n = i18n
    //从utils库内获取多语言文件，并配置
let messages = {
    'zh-CN': '/json/zh_CN.json',
    'en-US': '/json/en_US.json',
    'zh-TW': '/json/zh_HK.json',
    'zh-HK': '/json/zh_HK.json',
    'ko-KR': '/json/ko_KR.json',
    'id-ID': '/json/id_ID.json',
    'ja-JP': '/json/ja_JP.json',
    'vi-VN': '/json/vi_VN.json',
    'th-TH': '/json/th_TH.json',
    'ru-RU': '/json/ru_RU.json',
}
let promiseArr = []
Object.keys(messages).map(lang => {
    promiseArr.push(axios({
        url: CONFIG.utilsUrl + messages[lang],
        data: {lang}
    }))
})
const p = Promise.all(promiseArr)
p.then(res => {
    res.forEach(i => {
        const lang = JSON.parse(i.config.data).lang
        window.i18n.setLocaleMessage(lang, i.data)
    })
    store.commit('INIT',{
        showPage: true
    })
})
Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')